<template>
    <span class="c-text" :class="{ 'text-gray-500 dark:text-txt-body': variant === 'muted', 'text-primary-500': variant === 'primary' }"
        ><slot
    /></span>
</template>

<script setup lang="ts">
interface Props {
    variant?: 'muted' | 'primary'
}

defineProps<Props>()
</script>
